import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {TeamPermissionRole} from 'orgs/OrganizationConstants';

import GroupsSection, {GroupRowInfo} from './CreateUsersGroupSection';
import {CreateUsersModalTeam} from './CreateUsersModal';

export const EMPTY_TEAM_INFO: GroupRowInfo<CreateUsersModalTeam> = {
  group: null,
  role: TeamPermissionRole.MEMBER,
};

const TEAM_MEMBER_ROLE_TO_TEXT = {
  [TeamPermissionRole.ADMIN]: 'Admin',
  [TeamPermissionRole.MEMBER]: 'Member',
};

interface TeamSectionProps {
  onUpdate: (teamRowInfos: Array<GroupRowInfo<CreateUsersModalTeam>>) => void;
  teams: Array<CreateUsersModalTeam>;
  teamRowInfos: Array<GroupRowInfo<CreateUsersModalTeam>>;
}

export default function TeamsSection(props: TeamSectionProps): JSX.Element {
  return (
    <GroupsSection
      disabled={false}
      groups={props.teams}
      groupRowInfos={props.teamRowInfos}
      onUpdate={props.onUpdate}
      emptyRowInfo={EMPTY_TEAM_INFO}
      roleToText={TEAM_MEMBER_ROLE_TO_TEXT}
      groupType={ModelTypeConstants.TEAM}
    />
  );
}
